import React, {Component} from 'react'
import 'react-dates/initialize';
import {SingleDatePicker} from "react-dates";
import 'react-dates/lib/css/_datepicker.css';
import styles from './date.module.scss';
import "./_date.scss";
// src\images\calendar-icon.svg
import datePickerImg from 'images/calendar-icon.svg';

class DatePicker extends Component {
    state = {
        date: null,
        focused: false,
    };

    render() {
        const date_string_transformer = d => {
            // Represent date like "01/01/1111"
            return d ? `${d.substring(5,7)}/${d.substring(8,10)}/${d.substring(0,4)}` : "";
        }

        return <div className={"form-group " + styles["wrapper"]}>
            <SingleDatePicker
                date={typeof this.props.value === "string" ? null : this.props.value}
                placeholder={typeof this.props.value === "string" ? date_string_transformer(this.props.value) : "Select Date"}
                onDateChange={date => this.props.onChange({target: {name: this.props.name, value: date}})} // PropTypes.func.isRequired
                focused={this.state.focused} // PropTypes.bool
                onFocusChange={({focused}) => this.setState({focused})} // PropTypes.func.isRequired
                id="your_unique_id" // PropTypes.string.isRequired,
            />
            <span className={styles.calendarIcon} onClick={()=>{this.setState({focused: true})}}>
                <img src={datePickerImg} alt=""/>
            </span>
        </div>
    }
}

export default DatePicker
